import { template } from 'lodash';
import { components as Component } from '../../universal/common/constants';

import {
    getCompetitionId, getSeoServiceConfig, getSportsbookConfig, isCompetitionPage, isEventPage,
} from './bridge';

const PAGE = {
    EVENTS: 'events',
    COMPETITIONS: 'competitions',
    HIGHLIGHTS: 'highlights',
};

const isMainPage = (sport) => ['homepage', 'in-play'].includes(sport);

const isRacingPage = (sport) => ['horse-racing', 'greyhounds'].includes(sport);

const isHighlightsPage = (sport) => !isMainPage(sport) && !isRacingPage(sport);

const getTruePage = (page, sport) => {
    if (isEventPage()) return PAGE.EVENTS;
    if (isCompetitionPage()) return PAGE.COMPETITIONS;
    if (isHighlightsPage(sport)) return PAGE.HIGHLIGHTS;
    return page;
};

const isCustomContentEligible = (id) => {
    const { seoServiceConfiguration: { components } } = getSeoServiceConfig();
    const { customIds = [] } = components[Component.SUB_FEATURE];
    return customIds.includes(id);
};

const extendUrl = (url, customId) => `${url}/${customId}`;

const handleSquizMisconfiguration = (locale, sportEn) => {
    if (locale === 'es-es' && sportEn === 'ufc') {
        return 'ufc-mma';
    }

    return sportEn;
};

const resolveUrl = (serviceUrl, locale, sportEn, page) => {
    const adjustedSportEn = handleSquizMisconfiguration(locale, sportEn);
    const url = template(serviceUrl)({ locale, sportEn: adjustedSportEn, page });
    const customId = getCompetitionId();
    return isCustomContentEligible(customId) ? extendUrl(url, customId) : url;
};

export const getServiceUrl = () => {
    const { seoServiceConfiguration: { serviceUrl } } = getSeoServiceConfig();
    const { lang: locale, sportEn, page } = getSportsbookConfig();

    // true page needs to be computed because horse-racing sections do not update the page thus it holds wrong values
    const truePage = getTruePage(page, sportEn);
    if (locale && sportEn && truePage) {
        return resolveUrl(serviceUrl, locale, sportEn, truePage);
    }
    return undefined;
};

// eslint-disable-next-line import/prefer-default-export
export const getSeoData = () => {
    const serviceUrl = getServiceUrl();
    return (serviceUrl && fetch(serviceUrl)) || Promise.resolve();
};
